import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Navbar from '../frontend/Components/Navbar/Navbar'
import Landing from '../frontend/Components/Landing/Landing'
import About from '../frontend/Components/Landing/About/About'
import ErrorPage from '../frontend/Components/Loading/ErrorPage'
function Router() {
    return (
        <BrowserRouter>
            <Routes>
                <Route exact path={`/`} element={<Landing/>}/>
                <Route path='/*' element={<ErrorPage/>}/>
            </Routes>
        </BrowserRouter>
    )
}

export default Router